/**
 * Hand the browser a file to save, with no dialog beyond what its download settings add.
 * Returns the blob url; it is revoked after a short while unless keepUrl is set, in which
 * case the caller owns it (to open the file later) and revokes it with URL.revokeObjectURL.
 */
export function downloadBlob(content, filename, type = 'text/plain', {keepUrl = false} = {}) {
  const link = document.createElement('a');
  const url = URL.createObjectURL(content instanceof Blob ? content : new Blob([content], {type}));
  link.href = url;
  link.setAttribute('download', filename);
  // in the document while clicked: some browsers ignore the file name on a detached link
  document.body.appendChild(link);
  link.click();
  link.remove();
  if (!keepUrl) {
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }
  return url;
}

/**
 * Open a saved file in a new tab. Returns false when the browser's popup blocker
 * stopped it (it allows this only from a click, or once popups are allowed for the site).
 */
export function openInNewTab(url) {
  try {
    const opened = window.open(url, '_blank');
    return !!opened;
  } catch (e) {
    console.warn('could not open', url, e);
    return false;
  }
}
